import { render, staticRenderFns } from "./attended.vue?vue&type=template&id=5e045122&"
import script from "./attended.vue?vue&type=script&lang=js&"
export * from "./attended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports